module.exports = __webpack_public_path__ + "8c25d933e69b3e0d9db9679a6078c745.jpg";